// extracted by mini-css-extract-plugin
export var inline = "_wi-0";